<template>
  <div class="w-full">
    <!-- Progress bar -->
    <div class="relative h-1 bg-gray rounded-full mb-2">
      <div
        class="absolute top-0 left-0 h-full bg-green-100 rounded-full transition-all duration-300"
        :style="{ width: progressWidth }"
      ></div>
    </div>

    <!-- Steps -->
    <div class="flex justify-between gap-1">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="flex items-center gap-1"
      >
        <div
          class="rounded-full flex items-center justify-center font-semibold shrink-0"
          style="width: 1.6em; height: 1.6em;"
          :class="index + 1 <= currentStep
            ? 'bg-green-100 text-white'
            : 'bg-gray text-mid-gray'"
        >
          {{ index + 1 }}
        </div>
        <span
          class="font-semibold"
          :class="index + 1 <= currentStep ? 'text-green-100' : 'text-mid-gray font-extralight'"
        >
          {{ step }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepProgress',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    progressWidth() {
      const percent = ((this.currentStep) / (this.steps.length)) * 100
      return `${percent}%`
    },
  },
}
</script>
